import React, { useMemo } from "react";
import useFlightDetailsInfoController from "./useFlightDetailsInfo.controller.js";
import { Card, Stack, Tab } from "@bookingcom/bui-react";
import { flights_funnel_new_fd_page_mobile } from "../../../../../utils/experiments/funnel/flights_funnel_new_fd_page_mobile.js";
import { FlightDetailsSectionTitleMobileUI } from "../../../../ui/FlightDetails/FlightDetailsSectionTitle.mobile.ui.js";
import { useI18n, t } from "@bookingcom/lingojs-react";
import { hasRenderableReactContent } from "../../../../../utils/hasRenderableReactContent.js";
export default function FlightDetailsInfoTabsMobile({ flight, fetchStatus }) {
    const i18n = useI18n();
    const { itemsMap } = useFlightDetailsInfoController({ flight, fetchStatus });
    const { itemsMap: itemsMapWithExtrasBaggage } = useFlightDetailsInfoController({
        flight,
        fetchStatus,
        baggagesExtrasOnly: true
    });
    const isFlexibility = useMemo(() => hasRenderableReactContent(itemsMap?.fareRulesInfoWithPartials?.content) ||
        hasRenderableReactContent(itemsMap?.extraProductsInfo?.content) ||
        hasRenderableReactContent(itemsMap?.extraProductsInfo2?.content), [itemsMap]);
    const isBaggage = useMemo(() => hasRenderableReactContent(itemsMap?.baggageInfo?.content) ||
        hasRenderableReactContent(itemsMapWithExtrasBaggage?.extraProductsInfo?.content), [itemsMap, itemsMapWithExtrasBaggage]);
    const isUpgrade = useMemo(() => hasRenderableReactContent(itemsMap?.upgradeFareInfoMobile?.content), [itemsMap]);
    if (!isBaggage && !isFlexibility && !isUpgrade)
        return null;
    return (React.createElement(Stack, { gap: 4 },
        React.createElement(Stack, { gap: 2 },
            React.createElement(FlightDetailsSectionTitleMobileUI, { title: i18n.trans(t("flights_fd_heading_fare_extras")) }),
            React.createElement(Tab, { variant: "rounded", onTabChange: (id) => {
                    if (id === "flexibility" && isFlexibility) {
                        flights_funnel_new_fd_page_mobile.goals.flexibilityProtectionClick();
                    }
                } },
                isBaggage || isFlexibility ? (React.createElement(Tab.TriggerList, null,
                    isBaggage ? React.createElement(Tab.Trigger, { id: "baggages", text: i18n.trans(t("flights_fd_chip_baggage")) }) : undefined,
                    isFlexibility ? (React.createElement(Tab.Trigger, { id: "flexibility", text: i18n.trans(t("flights_fd_heading_flexibility")) })) : undefined)) : undefined,
                isBaggage ? (React.createElement(Tab.Panel, { mixin: { marginBlockStart: 4 }, id: "baggages" },
                    React.createElement(Card, null,
                        React.createElement(Stack, { gap: 4 },
                            hasRenderableReactContent(itemsMap?.baggageInfo?.content)
                                ? itemsMap?.baggageInfo?.content
                                : undefined,
                            hasRenderableReactContent(itemsMapWithExtrasBaggage?.extraProductsInfo?.content)
                                ? itemsMapWithExtrasBaggage?.extraProductsInfo?.content
                                : undefined)))) : undefined,
                isFlexibility ? (React.createElement(Tab.Panel, { mixin: { marginBlockStart: 4 }, id: "flexibility", attributes: { "data-testid": "flightdetails_ancillaries" } },
                    React.createElement(Card, null,
                        React.createElement(Stack, { gap: 4 },
                            hasRenderableReactContent(itemsMap?.fareRulesInfoWithPartials?.content)
                                ? itemsMap?.fareRulesInfoWithPartials?.content
                                : undefined,
                            hasRenderableReactContent(itemsMap?.extraProductsInfo?.content)
                                ? itemsMap?.extraProductsInfo?.content
                                : undefined,
                            hasRenderableReactContent(itemsMap?.extraProductsInfo2?.content)
                                ? itemsMap?.extraProductsInfo2?.content
                                : undefined)))) : undefined)),
        hasRenderableReactContent(itemsMap?.upgradeFareInfoMobile?.content)
            ? itemsMap?.upgradeFareInfoMobile?.content
            : undefined));
}
